import React, { useState, useEffect, useRef } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ServiceApi from './serviceApi';
import moment from 'moment'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import Gruppi from './gruppi.js'
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import Facebook from './facebook';

import { registerLocale } from "react-datepicker";
import it from 'date-fns/locale/it';
registerLocale('it', it)

const RegisterV3 = () => {

	const CENA = 'cena';
	const MINUTI_ANTICIPO_PRENOTAZIONE_DEFAULT = 30;

	const api = new ServiceApi();

	const [searchParams, setSearchParams] = useSearchParams();

	const buttonSubmitRef = useRef(null);//per evitare doppio click
	const [prenotazione, setPrenotazione] = useState({ intolleranze: [], motivo: [] });
	const [isLoading, setIsLoading] = useState(false);
	const [isAgreement, setIsAgreement] = useState(false);
	const [isPrenotazioneConfermata, setIsPrenotazioneConfermata] = useState(false);
	const [isPrenotazioneRifiutata, setIsPrenotazioneRifiutata] = useState(false);
	const [specials, setSpecials] = useState({});

	const [giorno, setGiorno] = useState();
	const [orario, setOrario] = useState("");
	const [persone, setPersone] = useState(0);
	const [note, setNote] = useState("");
	const [nome, setNome] = useState("");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");

	const [config, setConfig] = useState();
	const [menu, setMenu] = useState();
	const [piatti, setPiatti] = useState([]);
	const [message, setMessage] = useState();

	const [prenotazioneUuid, setPrenotazioneUuid] = useState();


	//------evento con parametri di input------

	const [isEvento, setIsEvento] = useState(false); //numero minimo e ruppi
	const [isNoPhoto, setIsNoPhoto] = useState(false); //grafica
	const [servizio, setServizio] = useState(); // pranzo / cena
	const [eventTitle, setEventTitle] = useState(); // titolo evento
	const [eventInfo, setEventInfo] = useState(); // informazioni evento, es { id: "2", name: "Le Grand Table", ... }
	
	//------------

	useEffect(() => {
	}, [prenotazione, giorno, persone, orario, specials, isAgreement]);

	useEffect(() => {
	
		api.config().then((data) => {

			
			setSpecials(data.specials);

			//titolo form
			const paramTitle = searchParams.get("evento");
			var formTitle = 'Prenota';
			if (paramTitle && data.eventi[paramTitle]){
				// parametro in input corrisponde a chiave delle label
				data.evento = data.eventi[paramTitle]; //aggiungo evento selezionato
				formTitle = data.evento.name;
				setEventInfo(data.evento);
				setServizio(data.evento.servizio);
				setFlagMotivoEvento(true, data.evento);

			}
			setConfig(data);
			setEventTitle(formTitle);
		});

		//parametri in query string per evento
		setIsNoPhoto(searchParams.get("nophoto") === 'true' );
		setIsEvento(  searchParams.get("evento") !== null );
		

	}, []);

	/**
	 * mostra nascone la scelta dell'evento nel form
	 * @returns 
	 */
	const getFormEvento = () => {
		return eventInfo;
	}

   /**
     * Abilita il checkbox solo se il giorno scelto (in formato numerico) è tra quelli dell'evento,
     * se il numero di persone soddisfa il minimo dell'evento
     * e se l'orario selezionato è coerente con il servizio dell'evento (es. "cena").
     * @returns {boolean}
     */
    const isEventoPrenotabile = () => {
        const eventForm = getFormEvento();
        // se non c'è evento, giorni o giorno selezionato => non prenotabile
        if (!eventForm || !Array.isArray(eventForm.days) || !giorno) return false;

        // controllo giorno (1 = lun, 7 = dom)
        const giornoNumero = moment(giorno).isoWeekday();
        if (!eventForm.days.includes(giornoNumero)) return false;

        // controllo sul numero minimo di persone (se definito nell'evento)
        const minPers = eventForm.minPersone || 0;
        if (minPers > 0 && (!persone || persone < minPers)) return false;

        // controllo sull'orario: prendo l'orario selezionato (dal payload o dallo state)
        const selectedOrario = (prenotazione && prenotazione.orario) ? prenotazione.orario : orario;
        if (!selectedOrario) return false;

		if (isOrarioValido(prenotazione.orario, eventForm.oreAnticipo) === false) return false;

        // determina il servizio da usare per validare gli orari:
        // priorità: servizio definito nell'evento -> servizio da query string -> default CENA
		if (eventForm.servizio){
			const servizioToUse = eventForm.servizio || servizio || CENA;

			// ottengo gli orari validi per il servizio (usa la funzione esistente che gestisce anche eccezioni)
			let validOrari = [];
			try {
				validOrari = getOrariPrenotazioni(servizioToUse) || [];
			} catch (e) {
				// fallback: prova a leggere direttamente dalla config senza lanciare errori
				if (config && config.orari && Array.isArray(config.orari[servizioToUse])) {
					validOrari = config.orari[servizioToUse];
				}
			}

			if (!Array.isArray(validOrari) || !validOrari.includes(selectedOrario)) return false;
		}

        return true;
    }

	const handleEventoCheckbox = (e) => {
		const ev = getFormEvento();
		setFlagMotivoEvento( e.target.checked, ev );
	}

    // gestisce il checkbox dell'evento: aggiunge/rimuove il nome evento in prenotazione.motivo
    const setFlagMotivoEvento = (isSelected, ev) => {
        
        if (!ev || !ev.name) return;
        const name = ev.name;
        const clone = Object.assign({}, prenotazione, { motivo: Array.isArray(prenotazione.motivo) ? [...prenotazione.motivo] : [] });

        if (isSelected) {
            if (!clone.motivo.includes(name)) {
                clone.motivo.push(name);
            }
        } else {
            clone.motivo = clone.motivo.filter(m => m !== name);
        }
        setPrenotazione(clone);
    };
	const verificaPrenotazione = (payload) => {

		if (payload.giorno !== undefined && payload.giorno !== null
			&& payload.peoples > 0 && payload.orario !== undefined && payload.orario !== '') {
			setIsLoading(true);
			payload.giorno = moment(payload.giorno).format('YYYY-MM-DD');

			if (isEvento){
				payload.serviziocustom = 'ev'; //ev_cena
			}

			api.verificaPrenotazione(payload).then((data) => {
				setIsLoading(false);
				prenotazione.disponibile = data.status;
				prenotazione.turni = data.turni;
				setPrenotazione(prenotazione);
				setMessage(config.messages[payload.giorno]);


				setIsPrenotazioneConfermata(false);
				setIsPrenotazioneRifiutata(false);
			});
		}
	};

	const handleChangeDate = (data) => {

		delete prenotazione.disponibile;
		prenotazione.giorno = data;
		setPrenotazione(prenotazione);

		setGiorno(data);
		verificaPrenotazione(prenotazione);

	};

	const onChangeOrario = (e) => {

		delete prenotazione.disponibile;
		prenotazione.orario = e.target.value;
		setPrenotazione(prenotazione);

		setOrario(e.target.value);
		verificaPrenotazione(prenotazione);
	};

	const onChangePersone = (e) => {

		delete prenotazione.disponibile;
		prenotazione.peoples = parseInt(e.target.value);

		if (isEvento){
			prenotazione.isMenuCompleto = true;
		}
		

		setPrenotazione(prenotazione);

		setPersone(parseInt(e.target.value));
		verificaPrenotazione(prenotazione);

		if (prenotazione.peoples > config.minGruppo && !isEvento) {
			loadMenuPerGruppi();
		}
	};


	const onChangeAgreement = (e) => {
		setIsAgreement(e.target.checked);
	};

	const handleOnChangeNote = (e) => {
		setNote(e.target.value);
	};
	const handleOnChangeNome = (e) => {
		setNome(e.target.value);
	};
	const handleOnChangeMail = (e) => {
		setEmail(e.target.value);
	};


	const handleChangeIntolleranze = (e) => {
		var value = e.target.value;
		if (e.target.checked) {
			prenotazione.intolleranze.push(value);
		} else {
			prenotazione.intolleranze = prenotazione.intolleranze.filter(data => data !== value);
		}
	};

	const handleChangeMotivo = (e) => {
		var value = e.target.value;
		if (e.target.checked) {
			prenotazione.motivo.push(value);
		} else {
			prenotazione.motivo = prenotazione.motivo.filter(data => data !== value);
		}
	};

	/**
	 * Click bottone prenota
	 * @param {*} event 
	 */
	const handleSubmit = (event) => {
		
		event.preventDefault();
		
		//console.log(buttonSubmitRef.current.disabled);
		if (buttonSubmitRef.current.disabled){
			console.log('return--------------');
			return;
		}
		buttonSubmitRef.current.disabled = true;

		//console.log('submit '+ new Date());
		
		prenotazione.giorno = moment(giorno).format('YYYY-MM-DD');
		prenotazione.note = note;
		prenotazione.name = nome;
		prenotazione.phone = phone;
		prenotazione.email = email;

		if (prenotazione.menu && prenotazione.menuSelected > 0 && config.prodottiMenu){
			// aggiungo i dolci
			prenotazione.menu = _.concat(prenotazione.menu, config.prodottiMenu[prenotazione.menuSelected.toString()] );
        }

		setIsPrenotazioneConfermata(false);
		setIsPrenotazioneRifiutata(false);
		setIsLoading(true);
		api.prenota(prenotazione).then((data) => {
			setIsLoading(false);
			if (data.confirmed) {
				setIsPrenotazioneConfermata(true);
				setPrenotazioneUuid(data.uuid);

				if (typeof window !== "undefined") {
					if (window.fbq != null) { 
					  window.fbq('track', 'PrenotazioneOk')
					}
				}

			} else {
				setIsPrenotazioneRifiutata(true);
			}
			buttonSubmitRef.current.disabled = false;

		});

	};

	/** 30 minuti di anticipo è il default*/
	const isOrarioValido = (orario, oreAnticipo) => {
		let anticipo = MINUTI_ANTICIPO_PRENOTAZIONE_DEFAULT;
		if (oreAnticipo){
			anticipo = oreAnticipo * 60;
		}else if (config && config.anticipoPrenotazioneMinuti){
			anticipo = config.anticipoPrenotazioneMinuti;
		}

		var iscurrentDate = moment(giorno).isSame(new Date(), 'day');
		if (iscurrentDate) {

			var str = moment(giorno).format('YYYY-MM-DD');

			var oraPrenotazione = moment(str + "T" + orario + ':00');
			var oraCorrente = moment(new Date());


			var duration = moment.duration(oraPrenotazione.diff(oraCorrente));
			var minutes = duration.asMinutes();
			if (minutes < anticipo) {
				return false;
			}

		}
		return true;
	};

	const loadMenuPerGruppi = () => {

		setIsLoading(true);

		api.menu().then((data) => {
			var filtered = _.reject(data.menu, function (e) {
				return e.cat === 'piatti-del-giorno' || e.cat === 'contornidelivery' || e.cat === 'dolci' || !e.showonline;
			});
			var groupedByCategory = _.groupBy(filtered, 'cat');
			setMenu(groupedByCategory);
			setIsLoading(false);
		});

	}

	const onChangeGruppi = () => {
		let clone = Object.assign({}, prenotazione);
		setPrenotazione(clone);
	}

	/*
		abilito solo il giorno in input (param query string)
	*/
	const filterDatePassed = (date) => {
		if (eventInfo?.days){
			const dateToCheck = moment(date);
			const eventEndDate = eventInfo.data_fine ? moment(eventInfo.data_fine) : null;
			if (eventEndDate && dateToCheck.isAfter(eventEndDate, 'day')) {
				return false;
			}

			let dayOfWeekPassed = dateToCheck.day();
			let listDaysOfWeek = getDaysFromFilter();
			return listDaysOfWeek.includes(dayOfWeekPassed);
		}else{
			return true;
		}

	};

	const getDaysFromFilter = () => {
		return  eventInfo.days;
	};

	    /**
     * restituisce gli orari in cui è possibile prenotare prendendoli dalla configurazione 
     * e gestendo il caso della domenica
     */
	const getOrariPrenotazioni = (servizio) =>{
		var cfg = config.orari;
		var orariList = cfg[servizio];
		if (giorno){
			var giornoCorrentNum = moment(giorno).isoWeekday();  // 7 domenica
			if (cfg.extra && cfg.extra[giornoCorrentNum] &&  cfg.extra[giornoCorrentNum][servizio]){
				return cfg.extra[giornoCorrentNum][servizio];
			}
		}
		return orariList;
	};

	const getHighlightDates = () => {
		if (eventInfo?.days){
			let listDaysOfWeek = getDaysFromFilter();
			const eventEndDate = eventInfo.data_fine ? moment(eventInfo.data_fine) : null;

			var listAllDays =[]; 
			listDaysOfWeek.forEach(function(dayToBeSelected){

				var weekDayToFind = moment().day(dayToBeSelected).weekday(); //change to searched day name

				var searchDate = moment(); //now or change to any date
				while (searchDate.weekday() !== weekDayToFind){ 
					searchDate.add(1, 'day'); 
				}
	
				var start = searchDate,
					end   = moment(searchDate).add(100, 'days'),
					day   = dayToBeSelected;
	
				var result = [start];
				var current = start.clone();
	
				while (current.day(7 + day).isBefore(end)) {
					result.push(current.clone());
				}
	
				var resDateObj = result
					.map(m => m.toDate())
					.filter(date => !eventEndDate || moment(date).isSameOrBefore(eventEndDate, 'day'));
				listAllDays = listAllDays.concat(resDateObj);
			});

			return listAllDays;
		}else{
			return [];
		}

	};


	

	return (
		<div >
		{config &&
		<div className="register register-with-news-feed">
			{!isNoPhoto &&
			<div className="news-feed">
				<div className="news-image" style={{ backgroundImage: `url(${config.sfondo})` }}></div>
				<div className="news-caption">
					<h4 className="caption-title">{config.titolo}</h4>
					<p>
					{config.label.sottotitolo}
					</p>
				</div>
			</div>
			}
			{isPrenotazioneConfermata ?
				<div className={"register-container " + (isNoPhoto ? "register-container-full" : "")}>
					<div className="register-header mb-15px ">
						<img alt="logo" src={config.logo}></img>	
					</div>
					<div className="register-header mb-25px h1">
						<div className="mb-1">Prenotazione confermata!</div>
						<small className="d-block fs-15px lh-16"></small>
					</div>
					<div className="register-content">
						<div className="alert alert-success fade show">
							<h2>Grazie per avere prenotato un tavolo! </h2>
								<h3>{config.label.confermaSottotitolo}</h3>
						</div>
						{config.walletDownloadLink && prenotazioneUuid && (
							<div>
								<p className="text-center">
									<a href={config.walletDownloadLink  + prenotazioneUuid+'.pkpass'} target="_blank" rel="noopener noreferrer">
										<img src="../../assets/img/IT_Add_to_Apple_Wallet.svg" alt="Add to Apple Wallet" />
									</a>
								</p>
							</div>
						)}
						<div className="mt-5">
							<p className="text-center"><h3>Nel frattempo puoi dare un'occhiata al menu <a href={config.linkMenu}>qui</a>.</h3></p>
						</div>
					</div>
				</div>
				:
				<div className={"register-container " + (isNoPhoto ? "register-container-full" : "")}>
					{!isNoPhoto &&
					<div>
						<div className="register-header mb-15px ">
							<img alt="logo" src={config.logo}></img>	
						</div>
						<div className="register-header mb-25px h1">
							<div className="mb-1">{eventTitle}</div>
							<small className="d-block fs-15px lh-16">Prenota un tavolo e verifica immediatamente la disponibilità.</small>
						</div>
					</div>
					}
					<div className="register-content">
						<form data-parsley-validate="true" onSubmit={handleSubmit} className="fs-13px">

							<div className="mb-3">
								<label className="col-lg-4 col-form-label">Scegli il giorno</label>
								<div className="col-md-12 col-lg-8">
									<DatePicker filterDate={filterDatePassed} highlightDates={getHighlightDates()} selected={giorno} inline locale="it" minDate={moment().toDate()} onChange={(date) => handleChangeDate(date)}  />
								</div>
							</div>

							<div className="mb-3">
								<label className="mb-2">Orario <span className="text-danger">*</span></label><br />
								{ (!servizio || servizio === 'pranzo') &&
								<ul className="list-group list-group-horizontal">
									{getOrariPrenotazioni('pranzo').map((item) => (
										isOrarioValido(item) &&
										<li className="list-group-item orario-wrap" key={item} >
											<input onChange={onChangeOrario} checked={prenotazione.orario === item} type="radio" className="btn-check" name="options"  id={item} autoComplete="off" value={item} />
											<label className="btn btn-outline-secondary" htmlFor={item}>{item}</label>
										</li>
									))}
								</ul>
								}
								
								<div className="mb-1"></div>
								{(!servizio || servizio === 'cena') &&
								<ul className="list-group list-group-horizontal">
									{getOrariPrenotazioni('cena').map((item) => (
										isOrarioValido(item) &&
										<li className="list-group-item orario-wrap" key={item} >
											<input onChange={onChangeOrario} checked={prenotazione.orario === item} type="radio" className="btn-check" name="optionscena"  id={item} autoComplete="off" value={item} />
											<label className="btn btn-outline-secondary" htmlFor={item}>{item}</label>
										</li>
									))}
									
								</ul>
								}
							</div>


							<div className="mb-3">
								<label className="mb-2">Numero di persone <span className="text-danger">*</span></label><br />

								<ul className="list-group list-group-horizontal">

								{Array.from({ length:  9  }).map((it, idxPers) => (
									idxPers > 0 && (!isEvento || (isEvento && idxPers >= config.evento.minPersone) ) &&
									<li className="list-group-item orario-wrap" key={"pl"+idxPers}>
										<input onChange={onChangePersone} checked={persone === idxPers} type="radio" className="btn-check" name="persone" id={"p"+idxPers} autoComplete="off" value={idxPers} />
										<label className="btn btn-outline-secondary" htmlFor={"p"+idxPers}>{idxPers}</label>
									</li>
								))}
								</ul>

								<div className="mt-2">
									<label className="mb-2">Siamo un gruppo&nbsp;&nbsp;</label>
									<select className="form-select" style={{'display':'inline', 'width':'auto'}} onChange={onChangePersone} value={persone}><option></option>
									{Array.from({ length: config.maxGruppo - 8  }).map((it, index) => <option value={9+index} key={index}>{9+index}</option>
									)}
									</select>
								</div>
							</div>

							{getFormEvento() && getFormEvento().formEnabled &&
							<div className="alert alert-pink fade show mb-4">
							<div className="form-check  ">
								<input disabled={!isEventoPrenotabile()} 
									onChange={handleEventoCheckbox}
									checked={prenotazione.motivo && getFormEvento() && prenotazione.motivo.includes(getFormEvento().name)}
									className="form-check-input" type="checkbox" id="eventoCheckbox" />
								<label className="form-check-label" htmlFor="eventoCheckbox">
									{getFormEvento().name}   <span style={{ fontStyle: "italic" }}>{getFormEvento().description}</span>
								</label>
								{!isOrarioValido(prenotazione.orario, getFormEvento().oreAnticipo) &&
									<div className="text-danger mt-2">
										<b>Devi prenotare con almeno {getFormEvento().oreAnticipo} ore di anticipo.</b>
									</div>
								}
							</div>
							</div>
							}

					{isLoading &&
						<div className="alert alert-secondary fade show">
							Verifica della disponibilità in corso...
						</div>
					}

					{prenotazione.disponibile !== undefined && !prenotazione.disponibile && prenotazione.turni.length === 0 &&
						<div className="alert alert-danger fade show">
							<span dangerouslySetInnerHTML={{__html: config.label.nonDisponibile}} />
						</div>
					}
					{prenotazione.disponibile !== undefined && !prenotazione.disponibile && prenotazione.turni.length > 0 &&
						<div className="alert alert-warning fade show">
							<span dangerouslySetInnerHTML={{__html: config.label.disponibileAltraFascia + prenotazione.turni.join(' oppure ') }} />
						</div>
					}
					{prenotazione.disponibile !== undefined && prenotazione.disponibile &&
						<div className="alert alert-success fade show">
							C'è un tavolo disponibile, puoi procedere con la prenotazione.
						</div>
					}
					{message !== undefined &&
						<div className="alert alert-warning fade show">
							<b>{message}</b>
						</div>
					}

					{prenotazione.disponibile &&
						<div>
							{!isEvento && prenotazione.peoples > config.minGruppo && menu &&
								<Gruppi menu={menu} prenotazione={prenotazione} piatti={piatti} notifyChange={onChangeGruppi} config={config}></Gruppi>
							}

							<div className="mb-3">
								<label className="form-label col-form-labelmb-2">Nome <span className="text-danger">*</span></label>
								<input type="text" className="form-control fs-13px" required value={nome} onChange={handleOnChangeNome} />
							</div>
							<div className="mb-3">
								<label className="form-label col-form-labelmb-2">Telefono <span className="text-danger">*</span></label>
								<PhoneInput
									required
									countryCallingCodeEditable={false}
									international={false}
									defaultCountry="IT"
									country="IT"
									value={phone}
									onChange={setPhone} 
									limitMaxLength={true}/>
							</div>
							<div className="mb-3">
								<label className="form-label col-form-label mb-2">Email <span className="text-danger">*</span></label>
								<input type="email" className="form-control fs-13px" required value={email} onChange={handleOnChangeMail} />
							</div>

							<div className="mb-3">
								<label className="form-label col-form-label col-md-12">Se hai note o rischieste scrivile qui</label>
								<div className="col-md-12">
									<textarea onChange={handleOnChangeNote} value={note} maxLength="300" className="form-control" rows="3"></textarea>
								</div>
							</div>

							{specials.intolleranze && specials.intolleranze.length > 0 &&
							<div className="mb-3">
								<label className="form-label col-form-label mb-2">Indicazioni alimentari</label>
								{specials.intolleranze.sort((a, b) => a.name.localeCompare(b.name)).map((item) => (
									<div className="form-check mb-2" key={item.id}>
										<input onChange={handleChangeIntolleranze} className="form-check-input" type="checkbox" id={item.id} value={item.name} />
										<label className="form-check-label" htmlFor={item.id}>
											{item.name}
										</label>
									</div>

								))}
							</div>
							}

							{specials.motivo && specials.motivo.length > 0 &&
							<div className="mb-3">
								<label className="form-label col-form-label mb-2">Motivo</label>
								{specials.motivo.sort((a, b) => a.name.localeCompare(b.name)).map((item) => (
									<div className="form-check mb-2" key={item.id}>
										<input onChange={handleChangeMotivo} className="form-check-input" type="checkbox" id={item.id} value={item.name} />
										<label className="form-check-label" htmlFor={item.id}>
											{item.name}
										</label>
									</div>

								))}
							</div>
							}
							

							<div className="form-check mb-4">
								<input onChange={onChangeAgreement} value={prenotazione.agreement} className="form-check-input" type="checkbox" id="agreementCheckbox" />
								<label className="form-check-label" htmlFor="agreementCheckbox">
									Procedendo, tu confermi di aver letto la nostra  <a href={config.linkPrivacy}>Privacy Policy</a>, sui dati e <a href={config.linkCookie}>l'utilizzo dei cookie</a>. <span className="text-danger">*</span>
								</label>
							</div>

							{isPrenotazioneRifiutata &&
								<div className="alert alert-danger fade show">
									Purtroppo non ci sono più tavoli disponibili per il giorno che hai scelto.
								</div>
							}

							<div className="mb-4">
								<button ref={buttonSubmitRef} disabled={!isAgreement || (prenotazione.peoples > config.minGruppo && !prenotazione.isMenuCompleto) || !prenotazione.disponibile} type="submit" className="btn btn-primary d-block w-100 btn-lg h-45px fs-13px">Prenota</button>
							</div>
							<p className="text-center"><em>{config.label.animali}</em></p>
						</div>
					}
					<hr className="bg-gray-600 opacity-2" />
					{!isNoPhoto &&
					<p className="text-center text-gray-600">
						&copy; {config.copyright}
					</p>
					}
				</form>
					</div>
				</div >
			}
		</div >
		}
		{config && config.facebookPixelId &&
		<Facebook config={config}></Facebook>
		}
		</div >
	);

}

export default RegisterV3;